import { render, staticRenderFns } from "./academy-importer-page.vue?vue&type=template&id=e94f8d1e&"
import script from "./academy-importer-page.vue?vue&type=script&lang=js&"
export * from "./academy-importer-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports